import { extractNumericValue } from './numeric-value-extractor';

export function calculatePercentageOfTotal(metricValue: string | undefined, totalMetric: number): string {
  if (totalMetric > 0) {
    const numericValue = extractNumericValue(metricValue ?? '0');
    return ((numericValue / totalMetric) * 100).toFixed(2);
  }
  return '0.00';
}
